exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".buttons[data-v-77bd8072]{margin-top:10px;display:flex;justify-content:center}.buttons button[data-v-77bd8072],.buttons input[type=submit][data-v-77bd8072]{margin:10px 5px 15px}.buttons a[data-v-77bd8072]{color:#fff;background-color:#5698d2;padding:10px 15px;border-radius:5px;font-size:20px;font-weight:700;text-decoration:none;height:100%;margin:0 5px 5px;width:200px}.sub-buttons[data-v-77bd8072]{display:flex;flex-direction:column;justify-content:center;align-items:center}.sub-buttons a[data-v-77bd8072]{color:#fff;background-color:#5698d2;padding:10px 15px;border-radius:5px;font-size:20px;font-weight:700;text-decoration:none;width:200px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-77bd8072","scoped":true,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=1!./src/components/main/Login.vue
// module id = 643
// module chunks = 0